/* WARNING: DO NOT MODIFY THIS FILE DIRECTLY
      This file was auto-generated using ./bin/fetchHelpCaseStudy.ts 
*/

export const caseStudyData = [
  {
    title: 'How Pre-Launch Marketing Helped Danny Saltos Launch With 875 Subs',
    summary:
      '“Playbook made everything easy, even creating the programs. I can do everything from my phone if I need to, which is incredible. I didn’t have to do any of the backend work, and it was just easy. I don’t have to pay $100,000 to develop the app, they do it for me, and they take 20% of a client that I would have never reached on my own.”',
    url: 'https://help.playbookapp.io/en/articles/9478556-how-pre-launch-marketing-helped-danny-saltos-launch-with-875-subs',
  },
  {
    title:
      'Sally McRae Launched in 14 Days & Gained 500 Subscribers In Her First Week',
    summary:
      '"I have had a passion for training people in strength and fitness since 2007 when I first started my own business. As my business began to grow, I was unable to keep up with the demand, quality, and customization in which I Iike to work with people. I eventually realized that with the quickly changing way in which people train and work out, I needed a solid online platform; and an app was the best way to do what I needed to do.”',
    url: 'https://help.playbookapp.io/en/articles/9478541-sally-mcrae-launched-in-14-days-gained-500-subscribers-in-her-first-week',
  },
  {
    title:
      'Chanel DeLisser Created Her Own Promotional Assets & Launched With 800 Subscribers',
    summary:
      '“I’ve been in the online space for about three years prior to joining Playbook. So, I think a lot of my subscribers are still on the journey with me and move onto new platforms with me… I think my experience in the online space and offering my workouts online has allowed me to have that level of success with Playbook.”',
    url: 'https://help.playbookapp.io/en/articles/9478558-chanel-delisser-created-her-own-promotional-assets-launched-with-800-subscribers',
  },
  {
    title: 'How to Run a Challenge: Mariana Morais Case Study',
    summary:
      'We’ve shared how important challenges are and why they’re an asset to add to your app. Remember, challenges are essentially programs with entry rules and prizes.',
    url: 'https://help.playbookapp.io/en/articles/9478551-how-to-run-a-challenge-mariana-morais-case-study',
  },
  {
    title: 'How to Market Your App on TikTok: Bailey Nomi Case Study',
    summary:
      'Having a robust social media presence is essential to your success as a creator. We’ve covered the essentials of how to market your app on TikTok, and to dive in even further, we’re going to share a creator case study to further demonstrate how to market yourself on the platform.',
    url: 'https://help.playbookapp.io/en/articles/9478392-how-to-market-your-app-on-tiktok-bailey-nomi-case-study',
  },
];
